import React from 'react';

import './index.scss';
import { MdCode, MdLaunch } from 'react-icons/md';


const Card = ({photo, title, demo, github, description, tags}) => {
    return (
        <div className="card__portfolio">
                { github && <a title="Code" href={github} className="codeIcon" target="_blank" rel="noreferrer"><MdCode /></a> } 
                <div className="card__img">
                    <img src={photo} alt={title} />
                </div>
                <div className="card__title">
                    <h5>{title}</h5>
                    { demo && 
                        <a 
                            className="demoLink"
                            href={demo} 
                            target="_blank"
                            rel="noreferrer"
                            title="Demo Link"
                        >
                            <MdLaunch />
                        </a> 
                    }
                </div>
                <p>{description}</p>
                { tags && 
                    <div className="card__tags">
                        { tags.map(tag => <li className="card__tag">{tag.name}</li>) }
                    </div>
                }

        </div>
    );
}

export default Card;
